import { useEffect, useState } from 'react';
import { Breadcrumbs } from '../../../Themes/Components/AbstractElements';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import TableActions from '../../../Themes/Components/TableActions';
import { format } from 'date-fns';
import Loading from '../../../Themes/Components/Loading';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import RegimeMercadoriasService from '../../../Services/Regime/RegimeMercadoriasService';

const filtrosFixos = {
  numero_serie: { campo: 'numero_serie', label: 'S/N', tipo: 'string' },
  produto_nome: { campo: 'produto_nome', label: 'Nome Produto', tipo: 'string' },
  produto_codigo_interno: { campo: 'produto_codigo_interno', label: 'Código Interno Produto', tipo: 'string' },
  produto_codigo_pu: { campo: 'produto_codigo_pu', label: 'Código PU Produto', tipo: 'string' },
  data_entrada: {
    campo: 'data_entrada',
    label: 'Data de Entrada',
    tipo: 'daterange',
    campoInicio: 'data_entrada_inicio',
    campoFim: 'data_entrada_fim',
  },
  data_vencimento: {
    campo: 'data_vencimento',
    label: 'Data de Vencimento',
    tipo: 'daterange',
    campoInicio: 'data_vencimento_inicio',
    campoFim: 'data_vencimento_fim',
  },
};

const RegimeMercadoriasIndex = () => {
  const [tableData, setTableData] = useState({
    rows: [],
    total: 0,
    page: 1,
    limit: 20,
    sortColumn: null,
    sortOrder: null,
    filtros: {},
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const base = RegimeMercadoriasService.base;

  const colunas = [
    {
      name: '',
      id: 'actions',
      center: true,
      compact: true,
      width: '3vw',
      cell: (row) => (
        <>
          <i
            className='icofont icofont-eye-alt'
            onClick={() => navigate(`/${base}/view/${row.id}`)}
            style={{ fontSize: 20, cursor: 'pointer' }}
            title='Visualizar mercadoria'
          />
        </>
      ),
    },
    { name: 'Importador', id: 'importador', sortable: true, wrap: true, selector: (row) => row.importador },
    { name: 'Contrato', id: 'contrato', sortable: true, wrap: true, selector: (row) => row.contrato },
    { name: 'S/N', id: 'numero_serie', sortable: true, wrap: true, selector: (row) => row.numero_serie },
    { name: 'Lote', id: 'numero_lote', sortable: true, wrap: true, selector: (row) => row.numero_lote },
    { name: 'Data de Entrada', id: 'data_entrada', sortable: true, wrap: true, selector: (row) => row.data_entrada },
    {
      name: 'Data de Vencimento',
      id: 'data_vencimento',
      sortable: true,
      wrap: true,
      selector: (row) => row.data_vencimento,
    },
  ];

  useEffect(() => {
    const index = async () => {
      setLoading(true);

      try {
        const data = await RegimeMercadoriasService.index();

        setTableData((prev) => ({
          ...prev,
          rows: data.rows,
          total: data.pageInfo.total,
        }));
      } catch (error) {
        toast.error(error.message);
      }

      setLoading(false);
    };

    index();
  }, []);

  const handlePageChange = async (page, limit) => {
    try {
      setLoading(true);

      const data = await RegimeMercadoriasService.index(
        page,
        limit,
        tableData.sortColumn,
        tableData.sortOrder,
        tableData.filtros,
      );

      setTableData({
        ...tableData,
        rows: data.rows,
        total: data.pageInfo.total,
        page,
        limit,
      });
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  const handleSort = async (column, order) => {
    try {
      setLoading(true);

      const data = await RegimeMercadoriasService.index(
        tableData.page,
        tableData.limit,
        column.id,
        order,
        tableData.filtros,
      );

      setTableData({
        ...tableData,
        rows: data.rows,
        total: data.pageInfo.total,
        sortColumn: column.id,
        sortOrder: order,
      });
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  const handleSubmitFilters = async (values) => {
    if (Object.keys(values).length === 0) {
      toast.warning('Informe os filtros.');
      return;
    }

    const filtros = {};

    Object.keys(values).forEach((campo) => {
      let value = values[campo];

      if (value instanceof Date) {
        value = format(value, 'dd/MM/yyyy');
      }

      if (value !== null && value !== undefined && String(value).length > 0) {
        filtros[campo] = value;
      }
    });

    setLoading(true);

    try {
      const data = await RegimeMercadoriasService.index(
        1,
        tableData.limit,
        tableData.sortColumn,
        tableData.sortOrder,
        filtros,
      );

      setTableData({
        ...tableData,
        rows: data.rows,
        total: data.pageInfo.total,
        page: 1,
        filtros,
      });
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  const clearTable = async () => {
    setLoading(true);

    try {
      const data = await RegimeMercadoriasService.index();

      setTableData({
        rows: data.rows,
        total: data.pageInfo.total,
        page: 1,
        limit: 20,
        sortColumn: null,
        sortOrder: null,
        filtros: {},
      });
    } catch (error) {
      toast.error(error.message);
    }

    setLoading(false);
  };

  return (
    <>
      <Breadcrumbs mainTitle='Mercadorias' title='Mercadorias' parent='Regime' />
      <Container fluid={true}>
        <Row>
          <Col sm={12}>
            <Card>
              <CardHeader className='pb-0'>
                <TableActions
                  dataFilters={filtrosFixos}
                  clearTable={clearTable}
                  showFiltroFavoritos={false}
                  handleFilterSubmit={handleSubmitFilters}
                  title='mercadorias'
                />
              </CardHeader>
              <CardBody className='mt-0 pt-0 m-b-0'>
                <DataTable
                  noDataComponent='Nenhum registro encontrado.'
                  data={tableData.rows}
                  columns={colunas}
                  striped={true}
                  responsive={true}
                  highlightOnHover={true}
                  progressPending={loading}
                  progressComponent={<Loading />}
                  pagination
                  paginationServer={true}
                  paginationPerPage={tableData.limit}
                  paginationComponentOptions={{
                    noRowsPerPage: true,
                    rangeSeparatorText: 'de',
                  }}
                  onChangePage={(page) => handlePageChange(page, tableData.limit)}
                  onChangeRowsPerPage={(limit, page) => handlePageChange(page, limit)}
                  paginationTotalRows={tableData.total}
                  sortServer
                  onSort={handleSort}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RegimeMercadoriasIndex;
